import { render, staticRenderFns } from "./TqEditCompany.vue?vue&type=template&id=5e6caf82&"
import script from "./TqEditCompany.vue?vue&type=script&lang=js&"
export * from "./TqEditCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports